import {
  BarChart3,
  Calendar,
  DollarSign,
  FileText,
  LucideProps,
  Phone,
  ShieldCheck,
  Sparkles,
} from 'lucide-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { PageContext } from '../../../../shared';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ChatMessage {
  text: string;
  isUser: boolean;
  timestamp: Date;
  /** Partial streamed text — used while WebSocket tokens arrive */
  streamingText?: string;
  isStreaming?: boolean;
  /** Thinking steps received during this response */
  thinkingSteps?: string[];
  /** Clarification options from needs_clarification response */
  clarificationOptions?: string[];
  /** Follow-up question suggestions from done event */
  followups?: string[];
}

export interface QuickQuestion {
  id: number;
  icon: ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>;
  label: string;
}

// ─── Quick question sets ──────────────────────────────────────────────────────

export const PLAN_COMPARISON_QUESTIONS: QuickQuestion[] = [
  { id: 1, icon: BarChart3,  label: "What's the difference between these plans?" },
  { id: 2, icon: DollarSign, label: 'Explain the cost break down for these plans' },
  { id: 3, icon: FileText,   label: 'What is the difference between Medicare Advantage and Medicare Supplement?' },
  { id: 4, icon: Sparkles,   label: 'Which plan do you recommend?' },
];

export const MARKETPLACE_QUESTIONS: QuickQuestion[] = [
  { id: 1, icon: BarChart3,  label: "Who is CoverRight? And are your services free?" },
  { id: 2, icon: DollarSign, label: 'When can I enroll into a plan?' },
  { id: 3, icon: FileText,   label: 'What is the difference between Medicare Advantage and Medicare Supplement?' },
];

export const PLAN_DETAILS_QUESTIONS: QuickQuestion[] = [
  { id: 1, icon: DollarSign,  label: 'How does the deductible work?' },
  { id: 2, icon: ShieldCheck, label: "What's covered in this plan?" },
  { id: 3, icon: Calendar,    label: 'How can I enroll in this plan?' },
];

export const EXPERT_QUESTIONS: QuickQuestion[] = [
  { id: 1, icon: Phone,    label: 'Who is CoverRight? And are your services free?' },
  { id: 2, icon: Calendar, label: 'How do I schedule a call?' },
];

// Static slots 3+4 per page — used when dynamic questions are available
export const RECOMMENDED_PLANS_STATIC_TWO: QuickQuestion[] = [
  { id: 3, icon: BarChart3, label: "Which plan do you recommend and why?" },
  { id: 4, icon: FileText,  label: 'What is the difference between Medicare Advantage and Medicare Supplement?' },
];

export const MARKETPLACE_STATIC_TWO: QuickQuestion[] = [
  { id: 3, icon: FileText,  label: 'What is the difference between Medicare Advantage and Medicare Supplement?' },
  { id: 4, icon: Sparkles,  label: 'Who is CoverRight? And are your services free?' },
];

export const PLAN_DETAILS_STATIC_TWO: QuickQuestion[] = [
  { id: 3, icon: ShieldCheck, label: "What's covered under this plan?" },
  { id: 4, icon: Calendar,    label: 'How can I enroll in this plan?' },
];

export const SCHEDULE_CALL_STATIC_TWO: QuickQuestion[] = [
  { id: 3, icon: Phone,    label: 'Who is CoverRight? And are your services free?' },
  { id: 4, icon: Calendar, label: 'How do I schedule a call?' },
];
